module.exports = __webpack_public_path__ + "img/blacklisted-contacts.7da1cbe8.svg";